import { useEffect, useState } from 'react';
import { useDecision } from '@optimizely/react-sdk';
import {
  FEATURES,
  VARIATIONS,
} from 'shared/app/components/optimizely/optimizely-keys';

const useDemystifyMenuFeatureFlag = () => {
  const [reviewDecision] = useDecision(FEATURES.DEMYSTIFY_REVIEW);

  const [menuPdpDecision] = useDecision(FEATURES.DEMYSTIFY_MENU_PDP);

  const [flags, setFlags] = useState({
    isDemystifyMenuEnabled: false,
    isDemystifyPdpEnabled: false,
    isDemystifyReviewEnabled: false,
  });

  useEffect(() => {
    if (reviewDecision) {
      setFlags((prev) => ({
        ...prev,
        isDemystifyReviewEnabled:
          (reviewDecision.enabled &&
            reviewDecision.variationKey ===
              VARIATIONS.SHOW_NEW_REVIEW_PRICING) ||
          false,
      }));
    }
  }, [reviewDecision]);

  useEffect(() => {
    if (menuPdpDecision) {
      setFlags((prev) => ({
        ...prev,
        isDemystifyMenuEnabled:
          (menuPdpDecision.enabled &&
            menuPdpDecision.variationKey ===
              VARIATIONS.SHOW_MENU_AND_PDP_PRICING) ||
          false,
        isDemystifyPdpEnabled:
          (menuPdpDecision.enabled &&
            [
              VARIATIONS.SHOW_MENU_AND_PDP_PRICING,
              VARIATIONS.SHOW_PDP_PRICING,
            ].includes(menuPdpDecision.variationKey)) ||
          false,
      }));
    }
  }, [menuPdpDecision]);

  return flags;
};

export default useDemystifyMenuFeatureFlag;
